import React from 'react'
import { withIcon } from '../../withIcon'

interface UserOutlineIconProps {
  size?: string
  color?: string
}

function UserOutlineIcon (props: UserOutlineIconProps) {
  const {
    size = '16px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <g transform="translate(2.25 1.25)">
        <path d="M10.7501 12.75C10.7501 11.8196 10.7501 11.3544 10.6424 10.9759C10.4 10.1236 9.77478 9.45669 8.97577 9.19816C8.6209 9.08333 8.18479 9.08333 7.31256 9.08333H4.18756C3.31533 9.08333 2.87922 9.08333 2.52435 9.19816C1.72534 9.45669 1.10009 10.1236 0.85771 10.9759C0.750061 11.3544 0.750061 11.8196 0.750061 12.75M8.56256 3.75C8.56256 5.40685 7.30336 6.75 5.75006 6.75C4.19676 6.75 2.93756 5.40685 2.93756 3.75C2.93756 2.09315 4.19676 0.75 5.75006 0.75C7.30336 0.75 8.56256 2.09315 8.56256 3.75Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  )
}

export default withIcon(UserOutlineIcon)
